import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/index/doctor-avatar.png';
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-8f743252"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  "class": "question"
};
var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("i", {
    "class": "icon-question-circle"
  }, null, -1);
});
var _hoisted_3 = ["innerHTML"];
var _hoisted_4 = {
  "class": "answer"
};
var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "avatar"
  }, [/*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })], -1);
});
var _hoisted_6 = {
  "class": "context"
};
var _hoisted_7 = {
  "class": "doctor-name"
};
var _hoisted_8 = {
  "class": "dialog"
};
var _hoisted_9 = ["innerHTML"];
var _hoisted_10 = {
  key: 0,
  "class": "empty-tip"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_Pagination = _resolveComponent("Pagination");
  return _openBlock(), _createElementBlock("div", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.questionList, function (item, index) {
    return _openBlock(), _createElementBlock("div", {
      "class": "item",
      key: index
    }, [_createElementVNode("div", _hoisted_1, [_hoisted_2, _createElementVNode("h3", {
      innerHTML: item.title
    }, null, 8, _hoisted_3)]), _createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("div", _hoisted_6, [_createElementVNode("p", _hoisted_7, [_createElementVNode("span", null, _toDisplayString(item.otherParameter.authorName), 1), _createElementVNode("span", null, _toDisplayString(item.otherParameter.professionalTitle) + " " + _toDisplayString(item.otherParameter.departmentName) + " " + _toDisplayString(item.otherParameter.hospitalName), 1)]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", {
      innerHTML: item.content
    }, null, 8, _hoisted_9)])])])]);
  }), 128)), !$data.questionList.length ? (_openBlock(), _createElementBlock("div", _hoisted_10, "没有找到要搜索的内容")) : _createCommentVNode("", true), _createVNode(_component_Pagination, {
    onCurrentChange: $options.currentChange,
    pageSize: $data.pageSize,
    total: $data.total,
    style: {
      "margin": "55px 0"
    }
  }, null, 8, ["onCurrentChange", "pageSize", "total"])]);
}